import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewIsClientPaginated } = listModuleLenses

export default (state, { moduleId }) => viewIsClientPaginated(moduleId, moduleDescriptions)
